<template>
    <rkm-overlay>
        <rkm-layout-body :title="id ? 'Agendamento de exames' : 'Cadastro de exames'">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    ref="Form"
                    :id="id"
                    @save="handleSave()"
                    @handleExitPaciente="handleExitPaciente"
                    @handleAtualizaPaciente="handleAtualizaPaciente"
                    @loaded="loaded"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/exame-imagem/agendamento/Form'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Mixins.
import {unmask} from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Form,
        ModalIntegracaoCns
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {

        this.setShowExitFormConfirmation()
    },
    data: () => ({
        additionals: null,
        enums: {classificacao},
        form: null,
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        loaded(value) {
            this.additionals = value.additionals
            this.form = value.form
        },
        handleExit() {

            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList();
            })
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'exame-imagem-agendamento-index' })
        },
        handleExitPaciente() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        handleAtualizaPaciente() {

            this.unsetShowExitFormConfirmation()

            this.$router.push({ name: 'cadastro-paciente-edit', params: { id: this.id } })
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.form.paciente.cidadao.id,
                nome: this.form.paciente.cidadao.nome,
                dataNascimento: this.form.paciente.cidadao.dataNascimento,
                nomeMae: this.form.paciente.cidadao.nomeMae,
                cns: this.form.paciente.cidadao && this.form.paciente.cidadao.cns ? this.unMaskCns(this.form.paciente.cidadao.cns) : null,
                cpf: this.form.paciente.cidadao && this.form.paciente.cidadao.cpf ? this.unMaskCpf(this.form.paciente.cidadao.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.form.paciente.cidadao, {
                nome: item.nome,
                nomeSocial: item.nomeSocial,
                dataNascimento: item.dataNascimento,
                idade: item.idade,
                sexo: {
                    id: item.sexo.id ?? null,
                    descricao: item.sexo.descricao ?? null,
                },
                nomeMae: item.nomeMae,
                nomePai: item.nomePai,
                cns: item.cns ? this.unMaskCns(item.cns) : null,
                cpf: item.cpf ? this.unMaskCpf(item.cpf) : null,
            })
        },
    },
    mixins: [unmask],
    props: {
        id: { type: Number, default: null }
    },
}
</script>